import { Grid } from '@mui/material';
import { VSpacer } from '@nx-smartmonkey/ui';

import ClaimAddStopsImg from '../../../assets/img/claims/stops/add_stops.svg';
import FilterExternalIdIcon from '../../../assets/img/claims/stops/export.svg';
import ClaimFilterStopsImg from '../../../assets/img/claims/stops/filter_results.svg';
import ClaimStopsImg from '../../../assets/img/claims/stops/stops.svg';
import { UnderLicenseClaim } from '../../../components/new-layout/UnderLicenseClaim';
import { intl } from '../../../helpers/IntGlobalProvider';
import Text from '../../../react-components/Text';

export const PlannerStopsUnderGorilla = () => {
  return (
    <div style={{ backgroundColor: `white`, width: `100%`, height: `100%` }}>
      <UnderLicenseClaim headerText={intl.formatMessage({ id: `planner.stops.under_gorilla_claim.title` })}>
        <Grid container direction="column" alignItems="center">
          <VSpacer large />
          <VSpacer medium />

          <Grid
            item
            container
            direction="column"
            alignItems="center"
            justifyContent="center"
            style={{ maxWidth: `700px` }}
          >
            <img src={ClaimStopsImg} alt="" height="200" width="200" />
            <VSpacer large />
            <Text
              variant="body-medium"
              style={{ textAlign: `center`, fontSize: `13px` }}
              intlId="planner.stops.under_gorilla_claim.header"
            />
          </Grid>

          <VSpacer large />

          <VSpacer large />

          <Grid item container direction="row" style={{ gap: `20px` }} alignItems="flex-start" justifyContent="center">
            <Grid
              item
              container
              direction="column"
              alignItems="center"
              justifyContent="center"
              style={{ maxWidth: `300px` }}
            >
              <Grid item style={{ height: `120px` }}>
                <img src={ClaimAddStopsImg} alt="" height="102" width="102" />
              </Grid>
              <VSpacer medium />
              <Grid item>
                <Text
                  style={{ textAlign: `center`, color: `#5073B5` }}
                  variant="h6"
                  intlId="planner.stops.under_gorilla_claim.content.1"
                />
              </Grid>
            </Grid>
            <Grid
              item
              container
              direction="column"
              alignItems="center"
              justifyContent="center"
              style={{ maxWidth: `300px` }}
            >
              <Grid item style={{ height: `120px` }}>
                <img src={ClaimFilterStopsImg} alt="" height="102" width="102" />
              </Grid>
              <VSpacer medium />
              <Grid item>
                <Text
                  style={{ textAlign: `center`, color: `#5073B5` }}
                  variant="h6"
                  intlId="planner.stops.under_gorilla_claim.content.2"
                />
              </Grid>
            </Grid>
            <Grid
              item
              container
              direction="column"
              alignItems="center"
              justifyContent="center"
              style={{ maxWidth: `300px` }}
            >
              <Grid item style={{ height: `120px` }}>
                <img src={FilterExternalIdIcon} alt="" height="102" width="102" />
              </Grid>
              <VSpacer medium />
              <Grid item>
                <Text
                  style={{ textAlign: `center`, color: `#5073B5` }}
                  variant="h6"
                  intlId="planner.stops.under_gorilla_claim.content.3"
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </UnderLicenseClaim>
    </div>
  );
};
